import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from 'ttag';
import useBasketContext from '../../../../../contexts/basket/useBasketContext';
import useGroupContext from '../../../../../contexts/group/useGroupContext';
import { CTA } from '../../../../general/Button';
import TinyModal from '../../../../general/TinyModal';

// What everyone still in a group order is told when it's over without being placed
const GroupEndedModal = () => {
    const groupContext = useGroupContext();
    const basketContext = useBasketContext();
    const navigate = useNavigate();

    if (groupContext.ended !== 'cancelled' || !groupContext.session) return null;

    const leave = () => {
        groupContext.clear();
        basketContext.clearBasket();
        navigate('/');
    };

    return (
        <TinyModal
            show={true}
            onHide={leave}
            modalID="group-ended-modal"
            header={t`This group order has ended`}
            footer={
                <CTA type="button" buddies onClick={leave}>
                    <span>{t`Back to the start`}</span>
                </CTA>
            }
        >
            <p>
                {groupContext.isLead
                    ? t`This group order has ended, as nothing was added to it for a while. Your basket has been emptied.`
                    : t`${groupContext.host ?? 'The host'} ended the group order, or it has run out of time. Your basket has been emptied.`}
            </p>
        </TinyModal>
    );
};

export default GroupEndedModal;
